import React, { useState } from "react";
import { Container } from "react-bootstrap";

import "./../../assets/css/otp-component.css";
import LoginCard from "../components/LoginCard";
import WelcomeCard from "../components/WelcomeCard";
import VerifyEmailCard from "../components/VerifyEmailCard";
import VerifyOTPCard from "../components/VerifyOTPCard";
import ResetPasswordCard from "../components/ResetPasswordCard";

const LoginPage = () => {
  const [activeCard, setActiveCard] = useState('LoginCard');
  const [mobileNumber, setMobileNumber] = useState(null);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState(null);

  const onEmailVerification = (email, mobileNumber) => {
    setMobileNumber(mobileNumber);
    setForgotPasswordEmail(email);
    setActiveCard('VerifyOTPCard');
  }

  const onOtpVerification = () => {
    setActiveCard('ResetPasswordCard');
  }

  return (
    <div className="login-page">
      <Container fluid className="d-lg-flex align-items-center justify-content-around">
        <div className="welcome-greet-container">
          <WelcomeCard />
        </div>
        <div className="login-card-container">
          {activeCard === 'LoginCard' && <LoginCard
            onForgotPasswordClick={() => setActiveCard('VerifyEmailCard')}
          />}
          {activeCard === 'VerifyEmailCard' && <VerifyEmailCard
            onSuccess={onEmailVerification}
            onBackClick={() => setActiveCard('LoginCard')}
          />}
          {activeCard === 'VerifyOTPCard' && <VerifyOTPCard
            mobileNumber={mobileNumber}
            onSuccess={onOtpVerification}
            onBackClick={() => setActiveCard('VerifyEmailCard')}
          />}
          {activeCard === 'ResetPasswordCard' && <ResetPasswordCard
            mobileNumber={mobileNumber}
            onSuccess={() => setActiveCard('LoginCard')}
          />}
        </div>
      </Container>
    </div>
  );
};

export default LoginPage;
